// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'

const config = useJwt.authConfig

const initialUser = () => {
  const item = window.localStorage.getItem('userData')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {}
}

export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    userData: initialUser()
  },
  reducers: {
    handleLogin: (state, action) => {
      const {accessToken, refreshToken, ...profile} = action.payload
      state.userData = profile
      state[config.storageTokenKeyName] = accessToken
      localStorage.setItem('userData', JSON.stringify(profile))
      if (accessToken) sessionStorage.setItem(config.storageTokenKeyName, accessToken)
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
    },
    handleLogout: state => {
      state.userData = {}
      state[config.storageTokenKeyName] = null
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.removeItem('userData')
      localStorage.removeItem(config.storageTokenKeyName)
      localStorage.removeItem('refreshToken')
      sessionStorage.removeItem(config.storageTokenKeyName)
    }
  }
})

export const { handleLogin, handleLogout } = authSlice.actions

export default authSlice.reducer
